(function($) {
	formHelper.addRule({
		form: '.form-search-mvw-holds',
		status: {
			SUCCESS: function() {
				this.redirect(this.data.redirectTo);
			}
		}
	});
})(jQuery);

jQuery(function initToolsSearchMVWHolds($) {
	$('.search-mvw-holds-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-search-mvw-holds');

		// Date Created Range
		// ------------------
		var $dateCreatedFrom = $('#date-created-start').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var dateCreatedFromPicker = $dateCreatedFrom.pickadate('picker');

		var $dateCreatedTo = $('#date-created-end').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var dateCreatedToPicker = $dateCreatedTo.pickadate('picker');

		// Check if there’s a “from” or “to” date to start with.
		if ( dateCreatedFromPicker.get('value') ) {
			dateCreatedToPicker.set('min', dateCreatedFromPicker.get('select'));
		}
		
		if ( dateCreatedToPicker.get('value') ) {
			dateCreatedFromPicker.set('max', dateCreatedToPicker.get('select'));
		}

		// When something is selected, update the "dateCreatedFrom" and "dateCreatedTo" limits.
		dateCreatedFromPicker.on('set', function(event) {
			if ( event.select ) {
				dateCreatedToPicker.set('min', dateCreatedFromPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				dateCreatedToPicker.set('min', false);
			}
		});

		dateCreatedToPicker.on('set', function(event) {
			if ( event.select ) {
				dateCreatedFromPicker.set('max', dateCreatedToPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				dateCreatedFromPicker.set('max', false);
			}
		});

		// Recent Hold Activity Date Range
		// ------------------
		var $recentHoldActivityFrom = $('#recent-hold-activity-date-start').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var recentHoldActivityFromPicker = $recentHoldActivityFrom.pickadate('picker');

		var $recentHoldActivityTo = $('#recent-hold-activity-date-end').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var recentHoldActivityToPicker = $recentHoldActivityTo.pickadate('picker');

		// Check if there’s a “from” or “to” date to start with.
		if ( recentHoldActivityFromPicker.get('value') ) {
			recentHoldActivityToPicker.set('min', recentHoldActivityFromPicker.get('select'));
		}
		
		if ( recentHoldActivityToPicker.get('value') ) {
			recentHoldActivityFromPicker.set('max', recentHoldActivityToPicker.get('select'));
		}

		// When something is selected, update the "recentActivityFrom" and "recentActivityTo" limits.
		recentHoldActivityFromPicker.on('set', function(event) {
			if ( event.select ) {
				recentHoldActivityToPicker.set('min', recentHoldActivityFromPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				recentHoldActivityToPicker.set('min', false);
			}
		});

		recentHoldActivityToPicker.on('set', function(event) {
			if ( event.select ) {
				recentHoldActivityFromPicker.set('max', recentHoldActivityToPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				recentHoldActivityFromPicker.set('max', false);
			}
		});
	});
});

jQuery(function initToolsSearchMVWHoldsResults($) {
	$('.search-mvw-holds-results-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-search-mvw-holds-results');
		var $pagesContainer        = $container.find('.tools-pages');
		var numPages               = $pagesContainer.data('pages');
		var currentPage            = $pagesContainer.data('start-page');

		for(var i = 1; i <= parseInt(numPages,10); i++) {
			if (i === parseInt(currentPage,10)) {
				currentClassCheck = " current";
			} else {
				currentClassCheck = '';
			}

			$pagesContainer.append('<div class="page' + currentClassCheck + '" data-page="' + i + '">' + i + '</div>');
		}

		// Bind all new page elements with page click function
		$(".page").click(function() {
			$('#filter-page').val($(this).data('page'));
			$form.submit();
		});

		// Bind refresh button
		$(".filter-refresh").click(function() {
			$('#filter-page').val(currentPage);
			$form.submit();
		});
	});
});